<template>
    
    <div  class="  ac-transition">
        <div class="card">
              <button type="reset" @click="printReceipt" class="btn b-light btn-danger-light btn-sm">Print Receipt</button>
        </div>
        <div class="grid grid-cols-12 bg-white">
          <div id="receipt"  class="receipt">
            <div class="receipt-container  ">
              <div class="border"></div>


         <div v-if="measurement_details && measurement_details.length" id="receipt">

        <div v-for="(item, index) in measurement_details" :key="item.id" class="border">

          <div class=card>
            <div class="card-body">


        
             <div class="row-between">
                <strong>Invoice No: {{ item.invoiceno }}</strong>
                <strong>Date: {{ item.entry_date }}</strong>
              </div>

                <div class="d-flex gap-2">
                
                  <strong v-if="item.halfshirt > 0"> halfshirt ({{ item.halfshirt }})</strong>
               
                  <strong v-if="item.fullshirt > 0"> fullshirt ({{ item.fullshirt }})</strong>
                  
                 
                   <strong v-if="item.pant > 0"> pant ({{ item.pant }})</strong>
                 
                    
                   </div>
          

                  <hr style="border:1px dashed black;">



             <!-- SHIRT -->
                <div v-if="item.halfshirt > 0 || item.fullshirt > 0">

                  <!-- <div><strong>{{ index + 1 }}. Shirt ({{ item.halfshirt || item.fullshirt }})</strong></div> -->
                  <div><strong>{{ item.stitching_label }}</strong></div>

                  <div class="plain-measurement" v-if="getValues(item).length">

                    <div>{{ getValues(item)[0] }}</div>

                    <div class="row3">
                      <span>{{ getValues(item)[1] }}</span>
                      <span>{{ getValues(item)[2] }}</span>
                      <span>{{ getValues(item)[3] }}</span>
                    </div>

                    <div class="row3">
                      <span>{{ getValues(item)[4] }}</span>
                      <span>{{ getValues(item)[5] }}</span>
                      <span>{{ getValues(item)[6] }}</span>
                    </div>

                    <div>{{ getValues(item)[7] }}</div>

                    <div class="row4">
                      <span>{{ getValues(item)[8] }}</span>
                      <span>{{ getValues(item)[9] }}</span>
                      <span>{{ getValues(item)[10] }}</span>
                      <span>{{ getValues(item)[11] }}</span>
                    </div>

                    <div>{{ getValues(item)[12] }}</div>
                    <div>{{ getValues(item)[13] }}</div>

                  </div>
                </div>


                <!-- PANT -->
                <div v-if="item.pant > 0">

                  <!-- <div><strong>{{ index + 1 }}. Pant ({{ item.pant }})</strong></div> -->
                  <div><strong>{{ item.stitching_label }}</strong></div>

                  <div class="plain-measurement" v-if="getValues(item).length">

                    <div>{{ getValues(item)[0] }}</div>

                    <div>{{ getValues(item)[1] }}</div>
                    <div>{{ getValues(item)[2] }}</div>
                    <div>{{ getValues(item)[3] }}</div>

                    <div class="row2">
                      <span>{{ getValues(item)[4] }}</span>
                      <span>{{ getValues(item)[5] }}</span>
                    </div>

                    <div>{{ getValues(item)[6] }}</div>
                    <div>{{ getValues(item)[7] }}</div>

                  </div>
                </div>











                    <span>{{ item.measurementnote }}</span>





          </div>
           </div>

        

        </div>

      </div>

    </div>
  </div>
        </div>
        </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      currentDate: new Date().toLocaleDateString(),
      receiptNumber: '',
      customer:[],
      invDetails:[],
      measurement_details:[], 
      order_items_under:[],
      measurements:[],
       
    };
  },
  computed: {
    totalAmount() {
      return this.items.reduce((total, item) => total + item.quantity * item.unitPrice, 0);
    },
  },
  mounted() { 
      if(this.$route.query.q)
            this.getBasics(this.$route.query.q); 
  },
  methods: {
     async getBasics(invoiceid) {
           var self=this;
             axios.post('get_new_measurement_print',{invoiceid:invoiceid}).then(function (response) {
                         self.measurement_details=response.data.measurement_details;
                         self.employees=response.data.userDetails;
                         self.invDetails=response.data.invDetails;
                         self.customer=response.data.customer;
                        self.order_items_under=response.data.order_items_details;
                        try {
                            document.getElementById("loader").remove();  
                          // self.printReceipt();
                        } catch (e) {}
                    }).then(()=>{ 
                      
                        
                        
                  
                        });;
      },
    formatCurrency(value) {
      return value;//`$${value.toFixed(2)}`;
    },
    printReceipt() {
      window.print();
    },

     getValues(item) {
    try {
      return JSON.parse(item.lablevalue || "[]");
    } catch (e) {
      return [];
    }
  }













  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@200;500&display=swap');



.row-between {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
}

.plain-measurement {
  font-weight: bold;
  margin-top: 6px;
  line-height: 2;
}

/* spacing exactly like image */
.row2 {
  display: flex;
  justify-content: space-between;
  width: 100px;
}

.row3 {
  display: flex;
  justify-content: space-between;
  width: 160px;
}

.row4 {
  display: flex;
  justify-content: space-between;
  width: 200px;
}

.plain-measurement span {
  display: inline-block;
  min-width: 20px;
}

/* highlight (pant first box) */
.highlight {
  background: yellow;
  display: inline-block;
  padding: 2px 6px;
}









.dn_f { 
  font-family: 'Noto Sans Devanagari', sans-serif;
  font-size: 14px;
}
.dn_f_only { 
  font-family: 'Noto Sans Devanagari', sans-serif;
}
tbody,table,.border{
    border-bottom: 1px dashed;
}
 #receipt {
  font-family: monospace;
  font-size: 16px;
  width: 68mm; /* Common width for thermal printers */
  padding: 5px;
}
table {
  width: 100%;
}
td, th {
  padding: 5px;
  text-align: left;
}


@media print {
    .note_for_item{
        text-wrap-mode: wrap;
    }
  button {
    display: none;
  }
 body {
        margin: -2rem 0 0 0;
        }
 #receipt {
   width: 250px; /* Ideal for thermal printers */
  font-family: Arial, sans-serif;
  font-size: 12px;
  line-height: 1.4;
  padding: 5px;
  
  /*border: 1px solid #000;*/
  margin: 0 auto;
  margin-top: -40px ;
  margin-left: 10px ;
  white-space: nowrap; /* Prevent text wrapping */
    }
    
    .dn_f_only{
      font-size: 16px;
      font-weight: 800;
    }
    .dn_f{
      font-size: 14px;
      
    }
}


</style>
